module.exports = __webpack_public_path__ + "img/Salary.a90eb18f.svg";